import * as jwtDecode from 'jwt-decode'
import { authService } from '../../../services/Auth'
import { riderService } from '../../../services/Rider'
import { driversService } from '../../../services/Drivers'
import { stationUserService } from '../../../services/StationUser'
import { teamMemberService } from '../../../services/OrganizationTeamMember'
import { teamMemberPermissionService } from '../../../services/TeamMemberPermission'
import {
  ActionsUnion,
  IMap,
  IUserAuthorizationFormData,
  IUserAuthorizationResponse,
  IChangePasswordObj,
  IUserRegisterFormData,
  IUserRegisterEmailFormData
} from '../../../types/'
import { setCurrentOrganization, getSingleOrganization } from '../organizations/index'
import { actionCreators as teamMemberPermissionActionCreators } from '../team-member-permission/index'

import * as constants from '../../constants/'
import { createAction } from '../helpers'
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'accessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refreshToken'
export const LOCAL_STORAGE_USER_TYPE = 'userType'
export const actionCreators = {
  clearAuthState: () => createAction(constants.CLEAR_AUTH_STATE),
  authRequest: () => createAction(constants.AUTHORIZATION_REQUEST),
  authSuccess: (authResp: IUserAuthorizationResponse) => createAction(constants.AUTHORIZATION_SUCCESS, authResp),
  authFail: (error: string) => createAction(constants.AUTHORIZATION_FAIL, error),
  registerRequest: () => createAction(constants.REGISTER_USER_REQUEST),
  registerSuccess: (registerResp: any) => createAction(constants.REGISTER_USER_SUCCESS, registerResp),
  registerFail: (error: string) => createAction(constants.REGISTER_USER_FAIL, error),
  checkTokenRequest: () => createAction(constants.CHECK_TOKEN_REQUEST),
  checkTokenSuccess: () => createAction(constants.CHECK_TOKEN_SUCCESS),
  checkTokenFail: (error: string) => createAction(constants.CHECK_TOKEN_FAIL, error),
  changePasswordRequest: () => createAction(constants.CHANGE_PASSWORD_REQUEST),
  changePasswordSuccess: () => createAction(constants.CHANGE_PASSWORD_SUCCESS),
  changePasswordFail: (error: string) => createAction(constants.CHANGE_PASSWORD_FAIL, error),
  recoverPasswordRequest: () => createAction(constants.RECOVER_PASSWORD_REQUEST),
  recoverPasswordSuccess: () => createAction(constants.RECOVER_PASSWORD_SUCCESS),
  recoverPasswordFail: (error: string) => createAction(constants.RECOVER_PASSWORD_FAIL, error),
  resetFetchSuccess: () => createAction(constants.RESET_FETCH_SUCCESS),
  userLogout: () => createAction(constants.USER_LOGOUT)
}
export type IAuthActions = ActionsUnion<typeof actionCreators>

export function userRegister(data: IUserRegisterFormData, { setSubmitting }: any) {
  const { registerRequest, registerSuccess, registerFail } = actionCreators
  return (dispatch: any) => {
    dispatch(registerRequest())
    authService.signUp(data).then(
      (data: IUserRegisterFormData) => {
        setSubmitting(false)
        dispatch(registerSuccess(data))
      },
      (response: any) => {
        setSubmitting(false)
        dispatch(registerFail(response.data))
      }
    )
  }
}

export function resendInviteEmail(data: IUserRegisterEmailFormData) {
  return (dispatch: any) => {
    return authService.resendInviteEmail(data).then(
      (data: any) => {
        return data
      },
      (response: any) => {
        throw new Error(response)
      }
    )
  }
}

export function userAuthorization(data: IUserAuthorizationFormData, { setSubmitting }: any) {
  const { authRequest, authSuccess, authFail } = actionCreators
  return (dispatch: any) => {
    dispatch(authRequest())
    authService.signIn(data).then(
      async (data: IUserAuthorizationResponse) => {
        const user: any = jwtDecode(data.accessToken)
        localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, data.accessToken)
        localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, data.refreshToken)
        let rider = null
        let driver = null
        let stationUser = null
        let permission = null
        try {
          rider = await riderService.getRiderPersonalInfo(user.id)
        } catch (error) {
          // Do nothing
        }
        try {
          driver = await driversService.getDriverById(user.id)
        } catch (error) {
          // Do nothing
        }
        try {
          stationUser = await stationUserService.fetchByUserId(user.id)
          stationUser = stationUser && stationUser[0]
          dispatch(setCurrentOrganization(stationUser.organizationId))
          dispatch(getSingleOrganization(stationUser.organizationId))
        } catch (error) {
          // Do nothing
        }
        try {
          permission = await teamMemberPermissionService.fetchByUserId(user.id)
          dispatch(teamMemberPermissionActionCreators.setCurrentTeamMemberPermission(permission))
        } catch (error) {
          // Do nothing
        }
        let type = ''
        if (rider) {
          type = 'rider'
        }
        if (driver) {
          type = 'driver'
        }
        if (stationUser) {
          type = 'station-user'
        }
        setSubmitting(false)
        dispatch(
          authSuccess({
            ...data,
            type
          })
        )
      },
      (response: any) => {
        setSubmitting(false)
        dispatch(authFail(response.data))
      }
    )
  }
}

export function changePassword(changePasswordObj: IChangePasswordObj) {
  const { changePasswordRequest, changePasswordSuccess, changePasswordFail } = actionCreators
  return (dispatch: any) => {
    dispatch(changePasswordRequest())
    authService
      .changePassword(changePasswordObj)
      .then(() => dispatch(changePasswordSuccess()), error => dispatch(changePasswordFail(error)))
  }
}

export function checkToken(token: string) {
  const { checkTokenRequest, checkTokenSuccess, checkTokenFail } = actionCreators
  return (dispatch: any) => {
    dispatch(checkTokenRequest())
    authService
      .checkToken(token)
      .then(() => dispatch(checkTokenSuccess()), ({ data: error }: { data: string }) => dispatch(checkTokenFail(error)))
  }
}

export const recoverPassword = (email: string) => (dispatch: any) => {
  const { recoverPasswordRequest, recoverPasswordSuccess, recoverPasswordFail } = actionCreators
  dispatch(recoverPasswordRequest())
  return authService.recoverPassword(email).then(
    user => {
      dispatch(recoverPasswordSuccess())
      return user
    },
    error => {
      dispatch(recoverPasswordFail(error))
      throw new Error(error)
    }
  )
}

export const acceptTeamInvite = (userId: string, organizationId: string) => (dispatch: any) => {
  return teamMemberService.acceptInvite(userId, organizationId)
}



// WEBPACK FOOTER //
// ./src/state/actions/auth/index.tsx